import { useEffect, useState } from "react";

import { type Product } from "@jti/magento";

export const useLoyaltyProductPoints = (items: Product[] = []): number => {
  const [totalPoints, setTotalPoints] = useState(0);

  useEffect(() => {
    setTotalPoints(items.reduce((prev: number, { points }: Product) => prev + (points || 0), 0));
  }, [items]);

  return totalPoints;
};
